import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { browserHistory } from 'react-router';
import SpecialitySelection from '@components/SpecialitySelection/SpecialitySelection';
import FooterButtons from '@components/Button/FooterButtons';
import * as actions from '../../actions';
import * as Constants from '../../constants';

require('../../components/SpecialitySelection/SpecialitySelection.scss');

const staticText = {
  backBtn: 'Back to Customer Info',
  proceedBtn: 'Proceed to Doctor Selection',
  cancelBtn: 'Cancel Order',
};

class SpecialitySelectionPage extends Component {
  componentDidMount() {
    this.props.actions.fetchSpecialities();
    this.props.actions.changeHeaderState(Constants.DOC_CONSULT_SEARCH);
  }

  handleSelect = (speciality) => {
    this.props.actions.setSelectedSpeciality(speciality.name);
  }

  handleProceed = () => {
    browserHistory.push('/doc-consult/select-doctor');
  }

  render() {
    const { specialitiesData, specialitiesTitle, loading, selectedSpeciality } = this.props.docConsult;

    return (
      <div className="specialitySelectionWrapper">
        <SpecialitySelection
          specialitiesData={specialitiesData}
          specialitiesTitle={specialitiesTitle}
          specialitiesLoading={loading}
          selectedSpeciality={selectedSpeciality}
          onSelect={this.handleSelect}
        />
        <FooterButtons
          backBtnText={staticText.backBtn}
          backBtnClick={() => browserHistory.push({ pathname: '/customer-info', state: { alreadyVisitedCustomerInfoPage: true } })}
          proceedBtnText={staticText.proceedBtn}
          proceedBtnClick={this.handleProceed}
          nextStateAllowed={!!selectedSpeciality}
          cancelBtnText={staticText.cancelBtn}
          cancelBtnClick={() => browserHistory.push({ pathname: '/customer-info', state: { alreadyVisitedCustomerInfoPage: true } })}
        />
      </div>
    );
  }
}

SpecialitySelectionPage.propTypes = {
  docConsult: PropTypes.object.isRequired,
  actions: PropTypes.object.isRequired,
};

export default connect(
  state => ({ docConsult: state.docConsult }),
  dispatch => ({ actions: bindActionCreators(actions, dispatch) })
)(SpecialitySelectionPage);
